export const SEND_REQUEST = 'LAYOUT/SEND_REQUEST';
export const SEND_REQUEST_SUCCESS = 'LAYOUT/SEND_REQUEST_SUCCESS';
export const SEND_REQUEST_ERROR = 'LAYOUT/SEND_REQUEST_ERROR';
export const FETCH_HELP_REQUEST_OPEN_TICKETS = 'LAYOUT/FETCH_HELP_REQUEST_OPEN_TICKETS';
export const FETCH_HELP_REQUEST_OPEN_TICKETS_SUCCESS = 'LAYOUT/FETCH_HELP_REQUEST_OPEN_TICKETS_SUCCESS';
export const FETCH_HELP_REQUEST_OPEN_TICKETS_ERROR = 'LAYOUT/FETCH_HELP_REQUEST_OPEN_TICKETS_ERROR';
export const CHECK_FITTING = 'LAYOUT/CHECK_FITTING';
export const CHECK_FITTING_SUCCESS = 'LAYOUT/CHECK_FITTING_SUCCESS';
export const CHECK_FITTING_ERROR = 'LAYOUT/CHECK_FITTING_ERROR';
export const SET_FIELD = 'LAYOUT/SET_FIELD';
export const ADD_FILE = 'LAYOUT/ADD_FILE';
export const REMOVE_FILE = 'LAYOUT/REMOVE_FILE';
export const CLEAR_FILES = 'LAYOUT/CLEAR_FILES';
export const SET_FITTING_MONTH = 'LAYOUT/SET_FITTING_MONTH';
export const SET_FITTING_DATE = 'LAYOUT/SET_FITTING_DATE';
export const RESET_FIELDS = 'LAYOUT/RESET_FIELDS';